<template>
    <template v-if="!isArrayEmpty($store.state.cart.dataRender[tabActive])">
        <h3 class="betslip__body-title">
            {{ getTranslatedText(tabActive) }}
        </h3>
        <div class="betslip__body-list">
            <template v-if="!this.$store.state.isScreenPhone">
                <div class="betslip__body-list__header">
                    <div class="betslip__body-list__header__no">
                        <span class="betslip__body-list__header-text">{{ getTranslatedText('No ticket') }}</span>
                    </div>
                    <div class="betslip__body-list__header__box">
                        <span class="betslip__body-list__header-text center">{{ getTranslatedText('Type') }}</span>
                        <span class="betslip__body-list__header-text">{{ getTranslatedText('Numbers') }}</span>
                        <span class="betslip__body-list__header-text last">{{ getTranslatedText('Amount') }}</span>
                        <span class="betslip__body-list__header-text last">{{ getTranslatedText('Time') }}</span>
                        <span class="betslip__body-list__header-text"></span>
                    </div>
                </div>
                <div class="betslip__body-item" v-for="(item, index) in $store.state.cart.dataRender[tabActive]" :key="index">
                    <div class="betslip__body-item__no">
                        <span class="betslip__body-item__no-text">{{ renderIndexTable(index) }}</span>
                    </div>
                    <div class="betslip__body-item__box">
                        <div class="betslip__body-item__box-type">
                            <div :class="['betslip__body-item__type', item?.img]">
                                <span class="betslip__body-item__type-text">{{ getTranslatedText(item.name) }}</span>
                            </div>
                        </div>
                        <div class="betslip__body-item__number">
                            <div class="betslip__body-item__number-item" v-for="(number, i) in item.selection" :key="i">
                                <span>{{ number }}</span>
                            </div>
                        </div>
                        <div class="betslip__body-item__price">
                            <span class="betslip__body-item__price-text"> {{ renderPrice(item.price) }}</span>
                        </div>
                        <div class="betslip__body-item__date">
                            <span class="betslip__body-item__date-text"> {{ renderDate(item.events.draw_date) }}</span>
                        </div>
                        <div class="betslip__body-item__close">
                            <img :src="require(`@/public/img/${$store.state.config.skin}/close.svg`)" @click="onRemoveItem(item)" />
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="betslip__body-item__box" v-for="(item, index) in $store.state.cart.dataRender[tabActive]" :key="index">
                    <div class="betslip__body-item__box-item">
                        <div :class="['betslip__body-item__type', item?.img]">
                            <span class="betslip__body-item-text">
                                {{ getTranslatedText(item.name) }}
                            </span>
                        </div>
                        <div class="betslip__body-item-column">
                            <span class="betslip__body-item-text draw-date">
                                {{ renderDate(item.events.draw_date) }}
                            </span>
                            <img
                                class="betslip__body-item-column-img"
                                :src="require(`@/public/img/${$store.state.config.skin}/close.svg`)"
                                @click="onRemoveItem(item)"
                            />
                        </div>
                    </div>
                    <div class="betslip__body-item__box-item">
                        <div class="betslip__body-item__number">
                            <div class="betslip__body-item__number-item" v-for="(number, i) in item.selection" :key="i">
                                <span>{{ number }}</span>
                            </div>
                        </div>
                        <span class="betslip__body-item-text price">
                            {{ renderPrice(item.price) }}
                        </span>
                    </div>
                </div>
            </template>
        </div>
        <div class="betslip__footer">
            <div class="betslip__footer-total">
                <span class="betslip__footer-total-title">
                    {{ getTranslatedText('total') }}
                </span>
                <span class="betslip__footer-total-price">
                    {{ renderTotal() }}
                </span>
            </div>
            <div class="betslip__footer-box-btn">
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    type="outline"
                    value="Effacer"
                    @on-click-button-common="onShowConfirmClear('onClearCart')"
                />
                <ButtonCommon :isNoHover="true" :isLoading="isLoadingButton" value="Valide" @on-click-button-common="onTransactCart('onClearCart')" />
            </div>
        </div>
    </template>
    <div v-else class="betslip__empty">
        <p>{{ getTranslatedText('cart empty') }}</p>
        <ButtonCommon :isNoHover="true" type="outline" value="Add Bets" @on-click-button-common="$emit('continue-paying')" />
    </div>
    <Dialog
        :show="dialog.isOpen"
        :buttonLeftName="`close`"
        :buttonRightName="`ok`"
        title="confirm"
        content="Are you sure you want to delete"
        @close="dialog.isOpen = false"
        @accept="onAccept"
    />
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import functionMixins from '@/mixins/function-utils';
import printMixins from '@/mixins/print-mixins';
import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';

import { formatDateUTC, formatPrice } from '@/utils/utils';
import LottoService from '@/services/loto/loto.service';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins, functionMixins, printMixins],
    components: { ButtonCommon, Dialog },
    data() {
        return {
            isLoadingButton: false,
            height: '500px',
            tabActive: 'okapi lottery',
            listGame: ['okapi lottery'],
            dialog: {
                isOpen: false,
                typeConfirm: '',
                item: null,
            },
        };
    },

    methods: {
        onAccept() {
            if (this.dialog.typeConfirm === 'onClearCart') this.onClearCart();
            else this.onRemoveItem(this.dialog.item);
        },

        onClearCart() {
            this.$store.dispatch('onClearCart', this.tabActive);
            this.dialog.isOpen = false;
            this.dialog.typeConfirm = '';
        },

        onShowConfirmClear(type, item = null) {
            this.dialog.isOpen = true;
            this.dialog.typeConfirm = type;
            this.dialog.item = item;
        },

        onRemoveItem(v) {
            const payLoad = {
                type: this.tabActive,
                item: v,
            };
            this.$store.dispatch('onRemoveItemCart', payLoad);
            this.dialog.isOpen = false;
        },

        async onTransactCart() {
            try {
                this.isLoadingButton = true;
                const respCheckdevice = await LottoService.deviceBindingcheck();
                if (respCheckdevice.code === 200 || respCheckdevice.status === 'success') {
                    const resp = await LottoService.transactLotto({
                        data: this.$store.state.cart.dataTransact[this.tabActive],
                    });
                    if (resp.status === 'success') {
                        const data = resp.data;
                        let dataPrint = {};
                        dataPrint['total_tickets'] = 0;
                        const tickets = data.bets.entries.map((element) => {
                            const item = {
                                game_name: element.game.game,
                                selection_bet: element.entry.bet,
                                wager: element.entry.wager,
                                loto_name: this.getTranslatedText(this.tabActive),
                                draw_date: this.renderDate(element.event.drawDate, true),
                            };

                            dataPrint.total_tickets += parseFloat(element.entry.wager);

                            return item;
                        });

                        dataPrint['title'] = this.getTranslatedText(this.tabActive);
                        dataPrint['currency'] = data.transaction.currency;
                        dataPrint['id'] = data.transaction.transaction_id;
                        dataPrint['tickets'] = tickets;
                        this.printLoto(dataPrint);
                        this.onClearCart();

                        const param = {
                            text: resp.message,
                            type: 'success',
                        };
                        EventBus.emit('show-notications', param);

                    } else {
                        const param = {
                            text: resp.message,
                            type: 'warning',
                        };
                        EventBus.emit('show-notications', param);
                    }
                } else {
                    const param = {
                        text: respCheckdevice.message,
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                }
            } catch (error) {
                const param = {
                    text: error === 'ECONNABORTED' ? this.getTranslatedText('Request timeout. Please check your network connection.') : error,
                    type: 'error',
                };
                EventBus.emit('show-notications', param);
                this.isLoadingButton = false;
                console.log(error);
            } finally {
                this.isLoadingButton = false;
            }
        },
        // common

        renderIndexTable(index) {
            let no = index + 1;
            no = no < 10 ? `0${no}` : no;
            return no;
        },

        renderDate(date, isHour24h = false) {
            const dateFormat = formatDateUTC(date, 2);
            const { hour12h, convertHour, hour, minutes, day, year, month } = dateFormat;

            const time = isHour24h ? ` ${hour}:${minutes}` : `- ${hour12h}${convertHour}`;

            const valueDate = `${day}/${month}/${year} ${time}`;

            return valueDate;
        },

        renderTotal() {
            const data = this.$store.state.cart.dataRender[this.tabActive];
            const totalPrice = data.reduce((acc, item) => acc + parseFloat(item.price), 0);
            return this.renderPrice(totalPrice);
        },

        renderPrice(price, decimal = 2) {
            return formatPrice(price, decimal);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/betslip/betslip.scss';
</style>
